import React, { useRef } from "react";
import { useNavigate } from "react-router";
import { AdminFormPage } from "@components/CatalogIndex/AdminFormPage";
import GovernanceForm from "../GovernanceForm/GovernanceForm";

const FORM_ID = "governance-form";

function New({
  project_id,
  account,
  permission,
  project,
  projectPhases,
  projectVariables,
}) {
  const navigate = useNavigate();
  const saveAndAddAnotherRef = useRef(false);

  const canSave =
    permission !== "view" && project?.data?.attributes?.status === "building";

  const triggerSaveAndAddAnother = () => {
    saveAndAddAnotherRef.current = true;
    (
      document.getElementById(FORM_ID) as HTMLFormElement | null
    )?.requestSubmit();
  };

  return (
    <AdminFormPage
      title="Add Governance"
      formId={canSave ? FORM_ID : undefined}
      onCancel={() =>
        navigate(`/projects/${project_id}/project_governances`, {
          state: null,
        })
      }
      onSaveAndAddAnother={canSave ? triggerSaveAndAddAnother : undefined}
    >
      <GovernanceForm
        formId={FORM_ID}
        saveAndAddAnotherRef={saveAndAddAnotherRef}
        project_id={project_id}
        account={account}
        permission={permission}
        project={project}
        projectPhases={projectPhases}
        projectVariables={projectVariables}
      />
    </AdminFormPage>
  );
}

export default New;
